import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["country", "classes"],
  _excluded2 = ["flag"];
import { MenuItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { forwardRef, useMemo } from 'react';
import { formatCountry, getCountryCode } from "../country-code-metadata/CountryCodeMetadata.js";
import { PhoneFieldFlag } from "./PhoneFieldFlag.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  dense: {},
  gutters: {},
  root: {},
  selected: {},
  flag: {
    marginRight: theme.spacing(1)
  }
}), {
  name: 'SD-PhoneFieldMenuItem'
});
export var PhoneFieldMenuItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      country,
      classes
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      classes
    }),
    {
      flag: flagClassName
    } = _useStyles,
    styles = _objectWithoutProperties(_useStyles, _excluded2);
  var countryCode = useMemo(() => getCountryCode(country), [country]);
  return /*#__PURE__*/_jsxs(MenuItem, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    button: true,
    classes: styles,
    children: [/*#__PURE__*/_jsx(PhoneFieldFlag, {
      country: country,
      className: flagClassName
    }), formatCountry(country), "\xA0", /*#__PURE__*/_jsx(Typography, {
      color: "textSecondary",
      children: countryCode
    })]
  }));
});
if (process.env.NODE_ENV !== "production") PhoneFieldMenuItem.displayName = "PhoneFieldMenuItem";